export interface DuaAiSummary {
  duas?: number;
  hisnMuslim?: number;
  matchedHisn?: number;
  matchedQuran?: number;
  unmatched?: number;
  fixSuggestions?: number;
  unchanged?: number;
  fields?: Record<string, number>;
  withWarnings?: number;
  newSuggestions?: number;
  newWithAudio?: number;
  skippedNotDua?: number;
  audioMissingBefore?: number;
  audioFound?: number;
  audioStillMissing?: number;
  errors?: string[];
  /** «Foreslå tashkeel» (lagt til i kjøringen etterpå). */
  tashkeel?: DuaAiTashkeelSummary;
}

export interface DuaAiTashkeelSummary {
  candidates: number;
  suggested: number;
  updatedPending: number;
  unchanged: number;
  withWarnings: number;
  alreadyFull: number;
  alreadyPending: number;
  noArabic: number;
  matchedSource: number;
  finishedAt?: string;
  errors?: string[];
}

/** Svar fra GET /api/v1/admin/dua-ai/tashkeel. */
export interface DuaTashkeelStats {
  total: number;
  empty: number;
  none: number;
  partial: number;
  full: number;
  fullRatio: number;
  lacking: {
    id: number;
    title: string | null;
    ratio: number;
    level: "NONE" | "PARTIAL";
    preview: string | null;
  }[];
}

export interface DuaAiRun {
  id: number;
  status: "RUNNING" | "DONE" | "FAILED";
  phase: string | null;
  total: number;
  processed: number;
  startedBy: string | null;
  startedAt: string;
  finishedAt: string | null;
  error: string | null;
  summary: DuaAiSummary | null;
  pendingFixes: number;
  pendingNew: number;
  accepted: number;
  rejected: number;
}

export interface DuaAiChange {
  field: string;
  label: string;
  before: string | null;
  after: string | null;
  reason: string | null;
}

export interface DuaAiSuggestion {
  id: number;
  runId: number;
  kind: "FIX" | "NEW";
  status: "PENDING" | "ACCEPTED" | "REJECTED";
  duaId: number | null;
  title: string | null;
  sourceRef: string | null;
  changes: DuaAiChange[];
  proposed: Record<string, string | null>;
  warnings: string[];
  audioSourceUrl: string | null;
  decidedBy: string | null;
  decidedAt: string | null;
  error: string | null;
}

export interface DuaAiDecisionResult {
  accepted: number;
  rejected: number;
  failed: { id: number; error: string }[];
}

/** Feltnavn i rapporten (samme som backend-etikettene). */
export const DUA_FIELD_LABELS: Record<string, string> = {
  tittel: "Tittel",
  kategori: "Kategori",
  arabisk: "Arabisk",
  arabisk1: "Arabisk uten vokaltegn",
  oversettelse: "Norsk oversettelse",
  engelsk: "Engelsk",
  urdu: "Urdu",
  transliteration: "Translitterasjon",
  referanse: "Referanse",
  tags: "Stikkord",
  lyd: "Lydfil",
};

/** Felt med høyre-til-venstre-skrift. */
export const RTL_FIELDS = new Set(["arabisk", "arabisk1", "urdu"]);

/** «hisn:27» → «Hisnul Muslim nr. 27», «quran:2:201» → «Koranen 2:201». */
export const sourceLabel = (ref: string | null): string | null => {
  if (!ref) return null;
  if (ref.startsWith("hisn:")) return `Hisnul Muslim nr. ${ref.slice(5)}`;
  if (ref.startsWith("quran:")) return `Koranen ${ref.slice(6)}`;
  return ref;
};
